import React, { useState } from "react";
import { Upload, Button, message } from "antd";
import {
  UploadOutlined,
  LoadingOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { uploadBackground, uploadLogo } from "../actions/stampcard_action";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const StampImageUploader = ({ label, onChange, initialPreviewUrl }) => {
  const { t } = useTranslation();
  const accUrn = useSelector((state) => state.account.urn);
  const businessSlug = useSelector((state) => state.account.businessSlug);

  const [previewUrl, setPreviewUrl] = useState(initialPreviewUrl || null);
  const [loading, setLoading] = useState(false);

  const beforeUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);

    try {
      let res;
      if (label === "Logo") {
        res = await uploadLogo({ data: formData, accUrn, businessSlug });
      } else {
        res = await uploadBackground({ data: formData, accUrn, businessSlug });
      }

      const { fileName } = res || {};
      if (!fileName) throw new Error("Missing fileName in response");

      const localUrl = URL.createObjectURL(file);
      setPreviewUrl(localUrl);
      onChange({ fileName, localUrl });
      message.success(t("image_uploader_success", { label }));
    } catch (err) {
      console.error(err);
      message.error(t("image_uploader_failed", { label }));
    } finally {
      setLoading(false);
    }

    return false; // prevent AntD auto-upload
  };

  const handleRemove = () => {
    setPreviewUrl(null);
    onChange(null);
    message.info(t("image_uploader_removed", { label }));
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <h4>{label}</h4>

      <Upload
        accept="image/*"
        showUploadList={false}
        beforeUpload={beforeUpload}
        disabled={loading}
      >
        <Button
          icon={loading ? <LoadingOutlined /> : <UploadOutlined />}
          loading={loading}
          style={{ marginRight: 8 }}
        >
          {loading
            ? t("image_uploader_uploading", { label })
            : t("image_uploader_upload", { label })}
        </Button>
      </Upload>

      {previewUrl && (
        <div
          style={{
            marginTop: 12,
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          <img
            src={previewUrl}
            alt={t("image_uploader_preview_alt", { label })}
            style={{
              maxWidth: "100%",
              height: 100,
              border: "1px solid #ddd",
              borderRadius: 6,
              objectFit: "contain",
            }}
          />
          <Button danger icon={<DeleteOutlined />} onClick={handleRemove}>
            {t("image_uploader_removed", { label })}
          </Button>
        </div>
      )}
    </div>
  );
};

export default StampImageUploader;
